"use client";

import { FC, useEffect } from "react";
import type { PaginationProps } from "antd/es/pagination";
import CustomIcon from "@/components/ui/custom-icon";
import { scrollToTop } from "@/utils/helpers";
import { useTranslations } from "next-intl";
import { useMedia } from "@/hooks/system/useMedia";
import Pagination from "antd/lib/pagination";
import S from "./index.module.scss";
import clsx from "clsx";

interface IPager {
  total: number;
  activePageNumber: number;
  activePageSize: number;

  onPageChangeHandler(page: number): void;
}

const Pager: FC<IPager> = ({ activePageSize, activePageNumber, onPageChangeHandler, total }) => {
  const { isClient, isMobile } = useMedia();
  const t = useTranslations();

  const itemRender: PaginationProps["itemRender"] = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className={clsx(S.dirWrapper, { [S["dirWrapper--prev"]]: true })}>
          <CustomIcon fileName={"icon-arrow-right"} /> {isClient && !isMobile && t("back")}
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className={S.dirWrapper}>
          {isClient && !isMobile && t("next")} <CustomIcon fileName={"icon-arrow-right"} />
        </a>
      );
    }
    return originalElement;
  };

  useEffect(() => {
    scrollToTop();
  }, [activePageNumber]);

  const pageChanger = (page: number) => {
    onPageChangeHandler(page);
  };

  return (
    <div className={S.pagerContainer}>
      <Pagination
        rootClassName={S.styledPagePagination}
        current={activePageNumber}
        defaultPageSize={activePageSize}
        total={total}
        itemRender={itemRender}
        hideOnSinglePage
        showSizeChanger={false}
        showTitle={false}
        onChange={page => pageChanger(page)}
      />
    </div>
  );
};

export default Pager;
